/**
 * 视频通话错误处理工具
 */

import { showDialog, showToast } from 'vant'
import { t } from '@/locales'
import router from '@/router'
import { SERVER_ERROR_CODE } from '@/common/constants'
/**
 * 处理视频通话错误
 * @param {Object} options - 选项
 * @param {number} options.code - 错误码
 * @param {string} options.message - 错误消息
 * @param {Object} options.data - 额外数据（如惩罚信息）
 * @param {boolean} [options.unMatchShowError=true] - 是否未匹配到特定错误码时显示错误信息（默认true）
 * @returns {boolean} - 是否匹配到特定错误码（true=匹配成功，false=未匹配）
 */
export function handleVideoCallError({ code, message }) {

  switch (code) {
    case SERVER_ERROR_CODE.INSUFFICIENT_COINS:
      // 金币不足 - 引导充值
      showDialog({
        title: t('videoCall.error.insufficientCoins.title'),
        message: t('videoCall.error.insufficientCoins.message'),
        confirmButtonText: t('videoCall.error.insufficientCoins.recharge'),
        cancelButtonText: t('common.cancel'),
        showCancelButton: true,
      }).then(() => {
        // 跳转到充值页面
        router.push({ path: '/product/diamond', state: { from: 'call_low_balance' } })
      }).catch(() => {
        // 用户取消
      })
      return

    case SERVER_ERROR_CODE.INSUFFICIENT_INTIMACY:
      // 亲密度不足
      showDialog({
        title: t('videoCall.error.insufficientIntimacy.title'),
        message: t('videoCall.error.insufficientIntimacy.message'),
        confirmButtonText: t('common.confirm'),
      })
      return

    // case SERVER_ERROR_CODE.EMPTY_BROADCAST_PENALTY:
    //   // 空播惩罚
    //   showDialog({
    //     title: t('videoCall.error.emptyBroadcastPenalty.title'),
    //     message: t('videoCall.error.emptyBroadcastPenalty.message'),
    //     confirmButtonText: t('common.confirm'),
    //   })
    //   return

    case SERVER_ERROR_CODE.REQUIRE_REAL_NAME:
      // 实名认证
      showDialog({
        title: t('videoCall.error.requireRealName.title'),
        message: t('videoCall.error.requireRealName.message'),
        confirmButtonText: t('videoCall.error.requireRealName.verify'),
        cancelButtonText: t('common.cancel'),
        showCancelButton: true,
      }).then(() => {
        // TODO: 跳转到实名认证页面（需要确认路由）
        console.log('[VideoCallError] Navigate to real name verification page')
        // router.push('/profile/verification')
      }).catch(() => {
        // 用户取消
      })
      return
    default:
      // 其他错误 - 直接显示错误信息
      showToast(message || t('videoCall.error.unknown'))
  }
}
